import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BaseComponent } from '../base/base.component';
import { IdDescription } from '../../models';
import { CustomerSelectService, UserCustomerReferenceService } from '../../services';
import { AuthService } from '../../../auth';

@Component({
  selector: 'app-customer-select',
  templateUrl: './customer-select.component.html',
  styleUrl: './customer-select.component.scss',
  imports: [FormsModule, AsyncPipe],
})
export class CustomerSelectComponent extends BaseComponent implements OnInit {
  protected readonly authService = inject(AuthService);
  protected readonly customerSelectService = inject(CustomerSelectService);
  private readonly userCustomerReferenceService = inject(UserCustomerReferenceService);

  customers$: Observable<IdDescription[]>;

  ngOnInit(): void {
    this.authService
      .isAuthenticated()
      .pipe(this.untilDestroyed())
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.customerSelectService.getCustomer().subscribe(() => this.getReferenceData());
        }
      });
  }

  private getReferenceData() {
    this.customers$ = this.userCustomerReferenceService.get().pipe(
      this.untilDestroyed(),
      tap((customers) => {
        if (!this.customerSelectService.currentCustomer && !!customers?.length) {
          this.customerSelectService.setCustomer(customers[0].id).subscribe();
        }
      }),
    );
  }

  setCustomer(event: any) {
    this.customerSelectService.setCustomer(event.target.value).subscribe();
  }
}
